import { Action, configureStore, ThunkAction } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// --- slices ---
import currencyReducer from './slices/currencySlice';

// --- reducers ---
import chatContactsReducer from './slices/chatContacts';
import chatMessagesReducer from './slices/chatMessages';
import logReducer from './slices/log';
import paramsReducer from './slices/params';
import productListReducer from './slices/productList';
import userReducer from './slices/user';
import cartReducer from './slices/cart';
import checkoutReducer from './slices/checkoutSlice';
import meetupLocationReducer from './slices/meetupLocationSlice';

// --- root reducer ---
const rootReducer = combineReducers({
    productList: productListReducer,
    params: paramsReducer,
    chatContacts: chatContactsReducer,
    chatMessages: chatMessagesReducer,
    user: userReducer,
    log: logReducer,
    cart: cartReducer,
    checkout: checkoutReducer,
    currency: currencyReducer,
    meetupLocation: meetupLocationReducer
});

// --- persist config ---
// Persist only what’s valuable across sessions
const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['user', 'cart', 'checkout', 'currency', 'meetupLocation'] // only these survive refresh
};

// wrap persisted root reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// --- store ---
export const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                // ignore redux-persist actions
                ignoredActions: ['persist/PERSIST']
            }
        })
});

export const persistor = persistStore(store);

// --- types ---
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;
